var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioWaveform({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 92",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 92,
    fill: "#f5f3ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7c3aed",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 58,
    x2: 24,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 66,
    x2: 40,
    y2: 26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 52,
    x2: 56,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 70,
    x2: 72,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 48,
    x2: 88,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 64,
    x2: 104,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 56,
    x2: 120,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136,
    y1: 72,
    x2: 136,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 50,
    x2: 152,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168,
    y1: 68,
    x2: 168,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184,
    y1: 54,
    x2: 184,
    y2: 38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 62,
    x2: 200,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216,
    y1: 46,
    x2: 216,
    y2: 46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232,
    y1: 66,
    x2: 232,
    y2: 26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248,
    y1: 52,
    x2: 248,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264,
    y1: 70,
    x2: 264,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 58,
    x2: 280,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296,
    y1: 64,
    x2: 296,
    y2: 28
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioWaveform);
export default __webpack_public_path__ + "static/media/audio_waveform.272f78e1fff0db2a8df56934906653f4.svg";
export { ForwardRef as ReactComponent };